import { NavLink } from "react-router-dom";

const cats = [
  {
    label: "Abbigliamento",
    group: "Donna",
    href: "/donna?cat=abbigliamento",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-8.png",
  },
  {
    label: "Scarpe",
    group: "Donna",
    href: "/donna?cat=scarpe",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-9.png",
  },
  {
    label: "Borse",
    group: "Donna",
    href: "/donna?cat=borse",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-10.png",
  },
  {
    label: "Abbigliamento",
    group: "Uomo",
    href: "/uomo?cat=abbigliamento",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-4_a286bbbe-0749-45be-b825-3c0bb2da8245.png",
  },
  {
    label: "Scarpe",
    group: "Uomo",
    href: "/uomo?cat=scarpe",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-11.png",
  },
  {
    label: "Borse e Zaini",
    group: "Uomo",
    href: "/uomo?cat=borse",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-12.png",
  },
];

export function CategoryGrid() {
  return (
    <section className="py-10 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-14">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-2 md:mb-3">Esplora</p>
          <h2 className="text-xl sm:text-2xl md:text-5xl text-stone-900 font-semibold md:font-bold tracking-tight leading-[1.05]">Le nostre categorie</h2>
          <p className="text-stone-500 text-xs sm:text-sm md:text-base mt-2 md:mt-4 max-w-md mx-auto leading-relaxed">Scelte raffinate per un guardaroba di classe</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {cats.map((cat) => (
            <NavLink
              key={`${cat.group}-${cat.label}`}
              to={cat.href}
              className="group relative overflow-hidden aspect-[3/4] bg-stone-200"
            >
              <img
                src={cat.image}
                alt={`${cat.group} ${cat.label}`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-emerald-400 text-[10px] tracking-[0.3em] uppercase font-semibold mb-1.5">{cat.group}</p>
                <h3 className="text-white text-base sm:text-lg md:text-2xl font-medium md:font-semibold tracking-tight leading-tight">{cat.label}</h3>
                <span className="inline-block mt-3 text-[10px] tracking-widest uppercase text-emerald-400 border-b border-emerald-400/50 pb-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                  Vai alla collezione →
                </span>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
}
